/* eslint-disable @typescript-eslint/explicit-function-return-type */
/* eslint-disable @typescript-eslint/explicit-module-boundary-types */
import { takeLatest, call, put, all, select } from 'redux-saga/effects';
import { ActionType } from 'typesafe-actions';
import * as actions from './actions';
import { ProductActionTypes } from './types';
import api from '../../../services/api';
import { StoreState } from '../../createStore';

export function* findProducts() {
  try {
    const { parameter, product }: StoreState = yield select();
    const { filters } = product;

    //konsole.log('findProducts: ', filters);
    const categoryFilter = !filters.categoryId ? '' : `&category=${filters.categoryId}`;
    const storeFilter = !parameter.multistoreSelected.store_id ? '' : `&store_id=${parameter.multistoreSelected.store_id}`;
    if (!filters.categoryId) filters.categoryId = '';
    if (!filters.order) filters.order = 'desc';
    const pageFilter = filters.page && filters.page > 1 ? `page=${filters.page}` : 'page=1'
    const limit = filters.limit || 18;

    const { data } = yield call(
      api.get,
      `product/searchall?limit=${limit}&mode=left&${pageFilter}&sort=price&order=${filters.order}&price=${filters.priceMin},${filters.priceMax}${categoryFilter}${storeFilter}`,
    );

    const response = {
      to: data.data.products.to,
      total: data.data.products.total,
      currentPage: data.data.products.current_page,
      lastPage: data.data.products.last_page,
    };

    if (filters.page && filters.page > 1) {
      yield put(actions.findProductsSuccessNextPage(data.data.products.data));
    } else {
      yield put(actions.findProductsSuccess(data.data.products.data));
    }
    yield put(actions.responseSuccess(response));
  } catch (err) {
    yield put(actions.findProductFailure());
  }

  return;
}

export function* searchProducts({
  payload,
}: ActionType<typeof actions.findProductSearch>) {
  try {
    const { filters } = payload;
    const { parameter }: StoreState = yield select();

    const storeFilter = !parameter.multistoreSelected.store_id ? '' : `&store_id=${parameter.multistoreSelected.store_id}`;
    if (!filters.categoryId) filters.categoryId = '1';
    if (!filters.order) filters.order = 'desc';

    const { data } = yield call(
      api.get,
      `product/searchall?term=${filters.term}&limit=10&mode=left&page=1&sort=price&order=${filters.order}&price=${filters.priceMin},${filters.priceMax}${storeFilter}`,
    );

     const response = {
      to: data.data.products.to,
      total: data.data.products.total,
      currentPage: data.data.products.current_page,
      lastPage: data.data.products.last_page,
    };

    yield put(actions.findProductSearchSuccess(data.data.products.data));
    yield put(actions.responseSuccess(response));
  } catch (err) {
    yield put(actions.findProductFailure());
  }
}

export function* findProduct({
  payload,
}: ActionType<typeof actions.findProduct>) {
  try {
    const { filters } = payload;
    const { parameter }: StoreState = yield select();

    const storeFilter = !parameter.multistoreSelected.store_id ? '' : `&store_id=${parameter.multistoreSelected.store_id}`;
    if (!filters.categoryId) filters.categoryId = '1';
    if (!filters.order) filters.order = 'desc';

    const { data } = yield call(
      api.get,
      `product/searchall?id=${filters.id}${storeFilter}`,
    );

     const response = {
      to: data.data.products.to,
      total: data.data.products.total,
      currentPage: data.data.products.current_page,
      lastPage: data.data.products.last_page,
    };

    yield put(actions.findProductSuccess(data.data.products.data[0] || {}));
    yield put(actions.responseSuccess(response));
  } catch (err) {
    yield put(actions.findProductFailure());
  }
}

export default all([
  takeLatest(ProductActionTypes.LOAD_REQUEST, findProducts),
  takeLatest(ProductActionTypes.SEARCH_REQUEST, searchProducts),
  takeLatest(ProductActionTypes.SEARCH_PRODUCT, findProduct),
]);
